<div class="lang-switch" role="radiogroup" [attr.aria-label]="'Change language' | translate">
  <svg class="lang-switch__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/>
    <path d="M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  </svg>
  <button [id]="idPrefix + '__langen'" type="button" class="lang-switch__option" role="radio"
    [class.active]="language.currentLang() === 'en'" [attr.aria-checked]="language.currentLang() === 'en'"
    (click)="language.setLanguage('en')">
    <span class="d-none d-sm-inline">English</span><span class="d-sm-none">EN</span>
  </button>
  <button [id]="idPrefix + '__langes'" type="button" class="lang-switch__option" role="radio"
    [class.active]="language.currentLang() === 'es'" [attr.aria-checked]="language.currentLang() === 'es'"
    (click)="language.setLanguage('es')">
    <span class="d-none d-sm-inline">Español</span><span class="d-sm-none">ES</span>
  </button>
</div>
